<template>

  <transition name="message">

    <li :class="[message.type]" v-if="show">

      <div class='header'>
        <img :src="icon_url[message.type]">
        <button class='uc' @click="closeMessage(message.id)">chiudi</button>
      </div>

      {{ message.message }}

    </li>

  </transition>

</template>

<script>
export default {

  props: ['message'],

  data: function () {

    return {
      show: false,
      delay: 2500,
      icon_url: {
        success: window.location.origin + '/media/icons/success.png',
        error: window.location.origin + '/media/icons/error.png',
        info: window.location.origin + '/media/icons/info.png',
      }
    }

  },

  methods: {

    closeMessage: function () {

      this.show = false;
      setTimeout(function (vue) {
        vue.$destroy();
      }, this.delay, this);

    }

  },

  mounted: function () {

    this.show = true;

    if (this.message.autoclose) {

      setTimeout(function (vue) {
        vue.closeMessage();
      }, 5000, this);

    }

  },

  // rimuovo l'elemento html dal DOM
  destroyed: function () {
    this.$el.remove();
  }

}
</script>

<style lang="scss" scoped>
.message-enter, .message-leave-to {
  transform: translateX(50%);
  opacity: 0;
}

.message-enter-to, .message-leave {
  transform: translateX(0);
  opacity: 1;
}

.message-enter-active, .message-leave-active {
  transition: all .2s linear;
}

li {
  padding: 1em;
  margin-top: 1em;
  width: 500px;
  font-size: .9em;
  position: relative;
  box-shadow: 2px 2px 4px gray;
  @media (max-width: 550px) {
    width: 90%;
  }
}

li.success {
  background-color: var(--green);
  color: black;
}

li.error {
  background-color: var(--red);
}

li.info {
  /* background-color: var(--blue-message); */
  background-color: #007bff;
  color: white;
}

li .header {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
}

li .header img {
  width: 20px;
  height: 20px;
}

button {
  font-size: .9em;
  background-color: transparent;
  /* border: 1px solid black; */
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  padding: 2px 10px;
}

li.info button {
  color: white;
}
</style>
